import ModalUploadSuccess from "./success";
import ModalUploadError from "./fail";

export { ModalUploadSuccess, ModalUploadError };



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/digital-certificate/components/modals/index.jsx